import { render } from "./NameLetters.vue?vue&type=template&id=71ccdba8&scoped=true"
import script from "./NameLetters.vue?vue&type=script&lang=js"
export * from "./NameLetters.vue?vue&type=script&lang=js"

import "./NameLetters.vue?vue&type=style&index=0&id=71ccdba8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-71ccdba8"

export default script